var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"fixed-qr-code"},[_c('span',{staticClass:"close-icon",on:{"click":_vm.closeQrCode}},[_vm._v("×")]),_vm._v(" "),_c('img',{attrs:{"src":require("@/assets/gbwhatsapp-qr-code-chat.webp"),"alt":"QR Code for download GB WhatsApp"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }